/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthAdditionalFormType } from './PalReauthAdditionalFormType';
import {
    PalReauthAdditionalFormTypeFromJSON,
    PalReauthAdditionalFormTypeFromJSONTyped,
    PalReauthAdditionalFormTypeToJSON,
    PalReauthAdditionalFormTypeToJSONTyped,
} from './PalReauthAdditionalFormType';

/**
 * 
 * @export
 * @interface PalReauthAdditionalFormCreateRequest
 */
export interface PalReauthAdditionalFormCreateRequest {
    /**
     * 
     */
    form_type: PalReauthAdditionalFormType;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    s3_key: string;
}



/**
 * Check if a given object implements the PalReauthAdditionalFormCreateRequest interface.
 */
export function instanceOfPalReauthAdditionalFormCreateRequest(value: object): value is PalReauthAdditionalFormCreateRequest {
    if (!('form_type' in value) || value['form_type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function PalReauthAdditionalFormCreateRequestFromJSON(json: any): PalReauthAdditionalFormCreateRequest {
    return PalReauthAdditionalFormCreateRequestFromJSONTyped(json, false);
}

export function PalReauthAdditionalFormCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthAdditionalFormCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'form_type': PalReauthAdditionalFormTypeFromJSON(json['form_type']),
        'name': json['name'],
        's3_key': json['s3_key'],
    };
}

export function PalReauthAdditionalFormCreateRequestToJSON(json: any): PalReauthAdditionalFormCreateRequest {
    return PalReauthAdditionalFormCreateRequestToJSONTyped(json, false);
}

export function PalReauthAdditionalFormCreateRequestToJSONTyped(value?: PalReauthAdditionalFormCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'form_type': PalReauthAdditionalFormTypeToJSON(value['form_type']),
        'name': value['name'],
        's3_key': value['s3_key'],
    };
}

